import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Button,
  TextField,
  Alert,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import QuizUpload from "./Quiz";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Assessmentmodify = (props) => {
  const vertical = 'top';
  const horizontal = 'center';
  const [open, setOpen] = React.useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  const [validationError, setvalidationError] = useState(false);
  const [error, setError] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSubmitQuestions({ data: "" });
  };

  const [submitQuestions, setSubmitQuestions] = useState({
    data: [],
  });

  const handleSubmitClick = (e) => {
    if (submitQuestions.data.length === 0) {
      setFileErrorMessage('Please select your excel file to upload questions');
      return;
    }
    const data = {
      data: submitQuestions.data,
      assessmentName: props.QuizName,
    }
    //console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/quizdataupdate/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          handleClose();
          setSubmitCompleted(true);
        }
        if (response.status === 404) {
          setvalidationError(true);
          const id = "errorMessage";
          setError((prevState) => ({
            ...prevState,
            [id]: [data.message],
          }));
        } else {
          handleClose();
          setSubmitCompleted(true);
          setOpen(false);
        }
        // Hide the Snackbar after 2 seconds (2000ms)
        setTimeout(() => {
          setSubmitCompleted(false);
        }, 2000);
        // return response.json();
      })
      .catch((error) => {
        console.error(error);
        setError({ errorMessage: "Something Went Wrong" });
      });
  };

  useEffect(() => {
    setFileErrorMessage("");
  }, [submitQuestions]);

  return (
    <>
      <Tooltip title="Modify" arrow>
        <span>
          <Button
            color="primary"
            variant="contained"
            size='small'
            startIcon={<CloudUploadIcon />}
            onClick={handleClickOpen}
            sx={{ borderRadius: '50px', px: 1.5, py: 0.5, fontSize: '0.75rem' }}
            aria-label="Modify"
          >
            Modify
          </Button>
        </span>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        PaperProps={{ style: { width: "100%", height: "32%" } }}
      >
        <DialogTitle id="form-dialog-title" style={{ fontSize: "17px" }}>
          Edit Assessment
        </DialogTitle>
        <DialogContent style={{ width: "100%", height: "32%" }}>
          <Grid container alignItems="center" style={{ marginTop: "20px" }}>
            <Grid item xs={12} sm={6} md={9}>
              <QuizUpload
                setSubmitQuestions={setSubmitQuestions}
                submitQuestions={submitQuestions}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={9}>
              <InputLabel style={{ marginTop: "5px" }}>
                Upload the Question file
                <small style={{ paddingLeft: "10px" }}>required</small>
                <small style={{ color: "red" }}>*</small>
                {fileErrorMessage && (
                  <Typography
                    color="error"
                    style={{
                      marginTop: "5px",
                      fontSize: "13px",
                      lineHeight: "1.2",
                    }}
                  >
                    {fileErrorMessage}
                  </Typography>
                )}
              </InputLabel>
            </Grid>
          </Grid>
        </DialogContent>{" "}
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <span>
              <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px', px: 1.5, py: 0.5, fontSize: '0.75rem' }} aria-label="Cancel">
                Cancel
              </Button>
            </span>
          </Tooltip>
          <Tooltip title="Update" arrow>
            <span>
              <Button type="submit" onClick={handleSubmitClick} variant="contained" color="primary" sx={{ borderRadius: '50px', px: 1.5, py: 0.5, fontSize: '0.75rem' }} aria-label="Update">
                Update
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={submitCompleted}
        autoHideDuration={2000} // Hide after 2 seconds
        onClose={() => setSubmitCompleted(false)} // Handle the Snackbar close
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          style={{ backgroundColor: "#38761d", fontSize: "20px" }}
          severity="info"
        >
          You have successfully updated the assessment questions!
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default Assessmentmodify;
